module.exports = __webpack_public_path__ + "static/img/Diamond4.618f8a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Diamond4.svg
// module id = MDbU
// module chunks = 35